import { useUsers } from "@/api/user.api";
import { useTenantStore } from "@/store/tenant/tenant.store";
import { useTranslation } from "react-i18next";
import { usersTableConfig } from "./users-table.config";
import { CardsDataTable } from "@/components/table/table";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Outlet, Routes, useNavigate } from "react-router";

export const Users = () => {
    const { t } = useTranslation();
    const selectedTenant = useTenantStore((state) => state.selectedTenant);
    const { data: userData } = useUsers(selectedTenant?.id);
    const navigate = useNavigate();

    return (
        <>
            <title>{t("users.title")}</title>

            <CardsDataTable
                title={t("users.title")}
                description={t("users.description")}
                columns={usersTableConfig}
                data={userData?.data ?? []}
                totalCount={userData?.totalCount ?? 0}
                currentPage={0}
                pageSize={10}
                actions={
                    <Button variant="outline" onClick={() => navigate("invite")}>
                        <Plus className="size-4" />
                        {t("users.invite")}
                    </Button>
                }
            />

            <Outlet />
        </>
    );
};
